import {minioBaseUrl} from "../data/defaultConfig";
import {useState} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {Document, Page} from "react-pdf";
import {MdNavigateBefore, MdNavigateNext} from "react-icons/md";
import PropTypes from "prop-types";
import {HiOutlineMagnifyingGlassPlus} from "react-icons/hi2";
import {HiOutlineMagnifyingGlassMinus} from "react-icons/hi2";
import {TbZoomReset} from "react-icons/tb";

export function PdfViewerCustom(props) {
    const {url} = props;
    const docs = [{uri: minioBaseUrl + url}];
    const [numPages, setNumPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [scale, setScale] = useState(1)

    function onDocumentLoadSuccess(pdfInfo) {

        setNumPages(pdfInfo.numPages);
    }

    return <Col>
        <Row>
            <Col>

            </Col>
            <Col>
                <Document onLoadSuccess={onDocumentLoadSuccess} file={docs[0].uri}>
                    <Page scale={scale} pageNumber={pageNumber}/>
                </Document>
            </Col>
            <Col>

            </Col>
        </Row>
        <Row className={"g-0 justify-content-center mb-3"}>
            <Col xs={'auto'}>
                <Button onClick={() => {
                    setScale(scale === 1.4 ? 1.4 : scale + 0.2);
                }} className={"btn-light rounded-5 p-0 me-2 "}>{<HiOutlineMagnifyingGlassPlus
                    style={{height: '30px', width: '30px'}}/>}</Button>
            </Col>
            <Col xs={'auto'}>
                <Button onClick={() => {
                    setScale(scale - 0.2);
                }} className={"btn-light rounded-5 p-0"}>{<HiOutlineMagnifyingGlassMinus
                    style={{height: '30px', width: '30px'}}/>}</Button>
            </Col>
            <Col xs={'auto'}>
                <Button onClick={() => {
                    setScale(1);
                }} className={"btn-light rounded-5 p-0 ms-2"}>{<TbZoomReset
                    style={{height: '30px', width: '30px'}}/>}</Button>
            </Col>
        </Row>
        <Row className={"g-0 justify-content-center"}>
            <Col xs={2} className={"text-end"}>
                <Button onClick={() => {
                    if (pageNumber - 1 > 0) setPageNumber(pageNumber - 1);
                }} className={"btn-light rounded-5 p-0"}>{<MdNavigateBefore
                    style={{height: '30px', width: '30px'}}/>}</Button>
            </Col>
            <Col xs={"auto"}>
                <p className={"m-0 p-0 "}>
                    Page {pageNumber} of {numPages}
                </p>
            </Col>
            <Col xs={2}><Button onClick={() => {
                if (pageNumber + 1 <= numPages) setPageNumber(pageNumber + 1);
            }} className={"btn-light p-0 rounded-5"}>{<MdNavigateNext
                style={{height: '30px', width: '30px'}}/>}</Button></Col>
        </Row>


    </Col>
}

PdfViewerCustom.propTypes = {url: PropTypes.string, parentWidth: PropTypes.number}